(function () {
  const selectors = {
    drawer: "[data-cart-drawer]",
    overlay: "[data-cd-overlay]",
    close: "[data-cd-close]",
    cartCount: "[data-cart-count]",
    body: "[data-cd-body]",
    footer: ".cd-footer",

    cartToggle: [
      ".js-cart-toggle",
      "[data-cart-toggle]",
      '[aria-controls*="cart"]',
      'button[name="open-cart"]'
    ].join(","),

    pageflyBtn: ".pf-button--revahs-hero-btn-main",
    pageflyATC: '[data-pf-type="ProductATC2"]'
  };

  const state = {
    busy: false,
    pfBusy: false
  };

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getDrawer() {
    const drawers = qsa(selectors.drawer);
    return drawers.length ? drawers[drawers.length - 1] : null;
  }

  function getOverlay() {
    const overlays = qsa(selectors.overlay);
    return overlays.length ? overlays[overlays.length - 1] : null;
  }

  function getBody() {
    const drawer = getDrawer();
    return drawer ? drawer.querySelector(selectors.body) : null;
  }

  function getFooter() {
    const drawer = getDrawer();
    return drawer ? drawer.querySelector(selectors.footer) : null;
  }

  function getShopBase() {
    const root =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : "/";
    return root.endsWith("/") ? root : root + "/";
  }

  function gotoCartPage() {
    window.location.href = getShopBase() + "cart";
  }

  function bump(el) {
    if (!el) return;
    el.classList.remove("cd-bump");
    void el.offsetWidth;
    el.classList.add("cd-bump");
    window.setTimeout(function () {
      el.classList.remove("cd-bump");
    }, 220);
  }

  function hasSelectedPdpUpsells() {
    return !!document.querySelector(
      '[data-revahs-upsells] input[data-upsell-variant-id]:checked'
    );
  }

  function setCartDrawerState(isOpen) {
    const method = isOpen ? "add" : "remove";

    document.documentElement.classList[method]("cart-drawer-open");
    if (document.body) {
      document.body.classList[method]("cart-drawer-open");
    }

    if (isOpen) {
      document.documentElement.style.overflow = "hidden";
      if (document.body) document.body.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "";
      if (document.body) document.body.style.overflow = "";
    }
  }

  function adjustBodyForFooter() {
    const body = getBody();
    const footer = getFooter();
    if (!body) return;

    const footerH = footer ? footer.getBoundingClientRect().height || 0 : 0;
    const pad = Math.max(160, Math.round(footerH + 18));
    body.style.paddingBottom = pad + "px";
  }

  function openDrawer() {
    const drawer = getDrawer();
    const overlay = getOverlay();
    if (!drawer || !overlay) return;

    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    overlay.hidden = false;

    setCartDrawerState(true);

    adjustBodyForFooter();

    const body = getBody();
    if (body) {
      try {
        body.scrollTo({ top: 0, behavior: "auto" });
      } catch (_) {
        body.scrollTop = 0;
      }
    }

    if (!drawer.hasAttribute("tabindex")) {
      drawer.setAttribute("tabindex", "-1");
    }

    try {
      drawer.focus({ preventScroll: true });
    } catch (_) {}

    window.setTimeout(adjustBodyForFooter, 80);
    window.setTimeout(adjustBodyForFooter, 250);
  }

  function closeDrawer() {
    const drawer = getDrawer();
    const overlay = getOverlay();
    if (!drawer || !overlay) return;

    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    overlay.hidden = true;

    setCartDrawerState(false);
  }

  async function fetchSectionHTML() {
    const base = getShopBase();
    const res = await fetch(base + "?sections=cart-drawer", {
      credentials: "same-origin"
    });
    const json = await res.json();
    return json["cart-drawer"];
  }

  function replaceDrawerHTML(html) {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;

    const newOverlay = tmp.querySelector(selectors.overlay);
    const newDrawer = tmp.querySelector(selectors.drawer);

    const overlay = getOverlay();
    const drawer = getDrawer();

    if (overlay && newOverlay) overlay.replaceWith(newOverlay);
    if (drawer && newDrawer) drawer.replaceWith(newDrawer);
  }

  async function refreshCartCount() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();

      qsa(selectors.cartCount).forEach(function (el) {
        el.textContent = cart.item_count;
      });

      return cart;
    } catch (_) {
      return null;
    }
  }

  async function refreshDrawer(opts) {
    const options = opts || {};
    const shouldOpen = options.open !== false;

    const html = await fetchSectionHTML();
    replaceDrawerHTML(html);
    await refreshCartCount();

    adjustBodyForFooter();

    if (shouldOpen) {
      openDrawer();
    }
  }

  function isCheckoutClickTarget(target) {
    const a = target.closest && target.closest("a");
    if (a) {
      const href = (a.getAttribute("href") || "").toLowerCase();
      if (href.indexOf("checkout") > -1) return true;
    }

    const btn =
      target.closest &&
      target.closest('button[name="checkout"], input[name="checkout"]');

    return !!btn;
  }

  function isCartLink(el) {
    if (!el || !el.closest) return false;

    const trigger = el.closest(
      '.js-cart-toggle, [data-cart-toggle], [aria-controls*="cart"], button[name="open-cart"], a[href]'
    );

    if (!trigger) return false;

    if (
      trigger.matches(
        '.js-cart-toggle, [data-cart-toggle], [aria-controls*="cart"], button[name="open-cart"]'
      )
    ) {
      return true;
    }

    if (trigger.tagName !== "A") return false;

    const href = trigger.getAttribute("href");
    if (!href) return false;

    try {
      const url = new URL(href, window.location.origin);
      const path = (url.pathname || "").replace(/\/+$/, "");
      return /(^|\/)cart$/.test(path);
    } catch (_) {
      return false;
    }
  }

  async function addToCartFromForm(form) {
    if (state.busy) return;
    state.busy = true;

    try {
      const formData = new FormData(form);
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
        credentials: "same-origin"
      });

      if (!res.ok) throw new Error("Add failed");

      await refreshDrawer({ open: true });
    } catch (_) {
      gotoCartPage();
    } finally {
      state.busy = false;
    }
  }

  async function addVariantById(variantId, btnEl) {
    if (state.busy) return;
    state.busy = true;

    const originalText = btnEl ? btnEl.textContent : null;
    const labelAdd = btnEl
      ? btnEl.getAttribute("data-label-add") || originalText || ""
      : "";
    const labelLoading = btnEl
      ? btnEl.getAttribute("data-label-loading") || "Adding…"
      : "Adding…";
    const labelAdded = btnEl
      ? btnEl.getAttribute("data-label-added") || "Added ✓"
      : "Added ✓";

    try {
      if (btnEl) {
        btnEl.disabled = true;
        btnEl.classList.add("is-loading");
        btnEl.textContent = labelLoading;
      }

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        }),
        credentials: "same-origin"
      });

      if (!res.ok) throw new Error("Add variant failed");

      if (btnEl) {
        btnEl.classList.remove("is-loading");
        btnEl.classList.add("is-added");
        btnEl.textContent = labelAdded;
      }

      await refreshDrawer({ open: true });
    } catch (_) {
      gotoCartPage();
    } finally {
      state.busy = false;

      if (btnEl) {
        window.setTimeout(function () {
          try {
            btnEl.classList.remove("is-loading");
            btnEl.classList.remove("is-added");
            btnEl.textContent = labelAdd || originalText || btnEl.textContent;
            btnEl.disabled = false;
          } catch (_) {}
        }, 900);
      }
    }
  }

  async function addVariantsByIds(variantIdsCsv, btnEl) {
    if (state.busy) return;
    state.busy = true;

    const originalText = btnEl ? btnEl.textContent : null;
    const labelAdd = btnEl
      ? btnEl.getAttribute("data-label-add") || originalText || ""
      : "";
    const labelLoading = btnEl
      ? btnEl.getAttribute("data-label-loading") || "Adding…"
      : "Adding…";
    const labelAdded = btnEl
      ? btnEl.getAttribute("data-label-added") || "Added ✓"
      : "Added ✓";

    try {
      if (btnEl) {
        btnEl.disabled = true;
        btnEl.classList.add("is-loading");
        btnEl.textContent = labelLoading;
      }

      const ids = String(variantIdsCsv || "")
        .split(",")
        .map(function (s) {
          return Number(String(s).trim());
        })
        .filter(function (n) {
          return !isNaN(n) && n > 0;
        });

      if (!ids.length) throw new Error("No variant ids");

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          items: ids.map(function (id) {
            return { id: id, quantity: 1 };
          })
        }),
        credentials: "same-origin"
      });

      if (!res.ok) throw new Error("Add variants failed");

      if (btnEl) {
        btnEl.classList.remove("is-loading");
        btnEl.classList.add("is-added");
        btnEl.textContent = labelAdded;
      }

      await refreshDrawer({ open: true });
    } catch (_) {
      gotoCartPage();
    } finally {
      state.busy = false;

      if (btnEl) {
        window.setTimeout(function () {
          try {
            btnEl.classList.remove("is-loading");
            btnEl.classList.remove("is-added");
            btnEl.textContent = labelAdd || originalText || btnEl.textContent;
            btnEl.disabled = false;
          } catch (_) {}
        }, 900);
      }
    }
  }

  async function changeLine(line, quantity) {
    if (state.busy) return;
    state.busy = true;

    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          line: Number(line),
          quantity: Number(quantity)
        }),
        credentials: "same-origin"
      });

      if (!res.ok) throw new Error("Change failed");

      await refreshDrawer({ open: true });
    } catch (_) {
      gotoCartPage();
    } finally {
      state.busy = false;
    }
  }

  function sleep(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  async function waitForCartCountChange(prevCount, attempts, intervalMs) {
    const totalAttempts = typeof attempts === "number" ? attempts : 14;
    const waitMs = typeof intervalMs === "number" ? intervalMs : 200;

    for (let i = 0; i < totalAttempts; i++) {
      await sleep(waitMs);
      const cart = await refreshCartCount();

      if (
        cart &&
        typeof cart.item_count === "number" &&
        cart.item_count !== prevCount
      ) {
        return cart;
      }
    }

    return await refreshCartCount();
  }

  async function handlePageFly(btn) {
    if (!btn || state.pfBusy) return;
    state.pfBusy = true;

    let prevCount = 0;

    try {
      const badge = document.querySelector(selectors.cartCount);
      prevCount = parseInt(
        (badge && badge.textContent ? badge.textContent : "0").trim(),
        10
      );
      if (isNaN(prevCount)) prevCount = 0;
    } catch (_) {}

    bump(btn);

    try {
      await waitForCartCountChange(prevCount, 14, 200);
      await refreshDrawer({ open: true });
    } catch (e) {
      console.warn("[Cart Drawer] refresh after PageFly failed", e);
    } finally {
      state.pfBusy = false;
      try {
        btn.classList.remove("is-loading");
      } catch (_) {}
    }
  }

  function bindDrawerEventsOnce() {
    if (document.documentElement.dataset.cdBound === "true") return;
    document.documentElement.dataset.cdBound = "true";

    document.addEventListener("click", function (e) {
      if (isCheckoutClickTarget(e.target)) return;

      if (e.target.closest(selectors.overlay)) {
        closeDrawer();
        return;
      }

      if (e.target.closest(selectors.close)) {
        closeDrawer();
        return;
      }

      if (isCartLink(e.target)) {
        e.preventDefault();
        refreshDrawer({ open: true });
        return;
      }

      const pfBtn =
        e.target.closest &&
        (e.target.closest(selectors.pageflyBtn) ||
          e.target.closest(selectors.pageflyATC));

      if (pfBtn) {
        if (hasSelectedPdpUpsells()) return;

        e.preventDefault();

        if (pfBtn.classList.contains("is-loading")) return;

        pfBtn.classList.add("is-loading");
        handlePageFly(pfBtn);
        return;
      }

      const drawer = e.target.closest(selectors.drawer);
      if (!drawer) return;

      const addMulti = e.target.closest("[data-add-variant-ids]");
      if (addMulti) {
        e.preventDefault();
        bump(addMulti);
        addVariantsByIds(addMulti.getAttribute("data-add-variant-ids"), addMulti);
        return;
      }

      const addUpsell = e.target.closest("[data-add-variant-id]");
      if (addUpsell) {
        e.preventDefault();
        bump(addUpsell);
        addVariantById(addUpsell.getAttribute("data-add-variant-id"), addUpsell);
        return;
      }

      const item = e.target.closest(".cd-item");
      if (!item) return;

      const line = item.getAttribute("data-line");
      const input = item.querySelector("[data-qty-input]");
      const current = Number(input && input.value ? input.value : 0);

      if (e.target.closest("[data-qty-minus]")) {
        e.preventDefault();
        bump(e.target.closest("[data-qty-minus]"));
        changeLine(line, Math.max(0, current - 1));
        return;
      }

      if (e.target.closest("[data-qty-plus]")) {
        e.preventDefault();
        bump(e.target.closest("[data-qty-plus]"));
        changeLine(line, current + 1);
        return;
      }

      if (e.target.closest("[data-remove]")) {
        e.preventDefault();
        bump(e.target.closest("[data-remove]"));
        changeLine(line, 0);
      }
    });

    document.addEventListener("change", function (e) {
      const drawer = e.target.closest(selectors.drawer);
      if (!drawer) return;

      const input = e.target.closest("[data-qty-input]");
      if (!input) return;

      const item = e.target.closest(".cd-item");
      if (!item) return;

      const line = item.getAttribute("data-line");
      const qty = Math.max(0, Number(input.value || 0));
      changeLine(line, qty);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });

    window.addEventListener("resize", adjustBodyForFooter);

    document.addEventListener("cart:open", function () {
      openDrawer();
    });

    document.addEventListener("cart:close", function () {
      closeDrawer();
    });

    document.addEventListener("cart:refresh", function (e) {
      var shouldOpen = e && e.detail && e.detail.open;
      refreshDrawer({ open: !!shouldOpen });
    });
  }

  function interceptAddToCartFormsOnce() {
    if (document.documentElement.dataset.cdFormsBound === "true") return;
    document.documentElement.dataset.cdFormsBound = "true";

    document.addEventListener("submit", function (e) {
      const form = e.target;
      if (!form || !(form instanceof HTMLFormElement)) return;

      if (form.querySelector('button[name="checkout"], input[name="checkout"]')) {
        return;
      }

      const action = (form.getAttribute("action") || "").toLowerCase();
      const isAdd = action.indexOf("/cart/add") > -1 || form.querySelector('input[name="id"]');
      const optOut = form.getAttribute("data-no-drawer") === "true";

      if (isAdd && !optOut) {
        e.preventDefault();
        addToCartFromForm(form);
      }
    });
  }

  function bindPageFlyCTA(doc) {
    if (
      !doc ||
      (doc.documentElement &&
        doc.documentElement.dataset &&
        doc.documentElement.dataset.pfCDBound === "true")
    ) {
      return;
    }

    doc.documentElement.dataset.pfCDBound = "true";

    doc.addEventListener(
      "click",
      function (e) {
        const btn =
          e.target.closest &&
          (e.target.closest(selectors.pageflyBtn) ||
            e.target.closest(selectors.pageflyATC));

        if (!btn) return;
        if (isCheckoutClickTarget(e.target)) return;
        if (hasSelectedPdpUpsells()) return;

        e.preventDefault();

        if (btn.classList.contains("is-loading")) return;

        btn.classList.add("is-loading");
        handlePageFly(btn);
      },
      true
    );
  }

  function bindInIframes() {
    document.querySelectorAll("iframe").forEach(function (fr) {
      try {
        if (fr.contentDocument) bindPageFlyCTA(fr.contentDocument);
      } catch (_) {}
    });
  }

  async function init() {
    setCartDrawerState(false);

    bindDrawerEventsOnce();
    interceptAddToCartFormsOnce();
    bindPageFlyCTA(document);

    bindInIframes();
    setTimeout(bindInIframes, 500);
    setTimeout(bindInIframes, 1500);
    setTimeout(bindInIframes, 3000);

    await refreshCartCount();
  }

  init();
})();